const navStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600;700;800;900&family=Inter:wght@300;400;500;600;700&display=swap');

  :root {
    --g1: #2e4a1a;
    --g2: #3d6622;
  }

  /* ── NAVBAR ── */
  .nav {
    height: 64px;
    display: flex; align-items: center; justify-content: space-between;
    padding: 0 72px;
    background: #fff;
    border-bottom: 1px solid #eee;
    position: sticky; top: 0; z-index: 200;
  }
  .nav-brand {
    font-family: 'Sora', sans-serif; font-size: 20px; font-weight: 700;
    color: #111; letter-spacing: -0.4px;
  }
  .nav-links { display: flex; gap: 44px; list-style: none; }
  .nav-links a {
    font-size: 16px; font-weight: 500; color: #222; text-decoration: none;
  }
  .nav-links a:hover { color: var(--g2); }
  .nav-links li:first-child a { font-weight: 700; }
  .nav-cta {
    background: var(--g1); color: #fff;
    font-family: 'Inter', sans-serif; font-size: 15px; font-weight: 600;
    padding: 12px 28px; border-radius: 8px; border: none; cursor: pointer; letter-spacing: 0.1px;
  }
  .nav-cta:hover { background: var(--g2); }
`;

export default function Navbar() {
  return (
    <>
      <style>{navStyles}</style>
      <nav className="nav">
        <div className="nav-brand">imTransporter</div>
        <ul className="nav-links">
          <li><a href="/">Enterprise</a></li>
          <li><a href="/login">Support</a></li>
        </ul>
        <button className="nav-cta">Get Started</button>
      </nav>
    </>
  );
}